import PropTypes from 'prop-types'

const shape = {
  en: PropTypes.shape({}),
  es: PropTypes.shape({}),
}

const defaultObj = {
  en: {},
  es: {},
}

export default {
  shape,
  defaultObj,
}
